import requests from '@/api/request';

function send(url, methods) {
  const method = methods || 'get';
  return requests[method](url);
}

function scroll() {
  return send('imgs/home');
}

/**
 * params id
 */
function project(data) {
  const { typeid, id } = data;
  const url = id > 0 ? `product/${id}` : `product/list/${typeid}`;
  return send(url);
}

function team() {
  return send('creator/list');
}

function jobs() {
  return send('job/list');
}

function categories() {
  return send('product/types');
}

/**
 * params id
 */
function news(id) {
  const url = id > 0 ? `news/${id}` : 'news/list';
  return send(url);
}
export {
  scroll,
  project,
  team,
  news,
  jobs,
  categories,
};
